export default "__VITE_ASSET__vY8hk7mo__"